module.exports = __webpack_public_path__ + "ecdb9f206f216404c79aaf90bc803cae.svg";